export default __webpack_public_path__ + "static/media/help-center-featured.580133fc.svg";